export default __webpack_public_path__ + "static/media/aside-vip-logo-diamond.fa10c3a8.webp";